// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import splitPassiveRepeaterIntoSegmentEnds from './splitPassiveRepeaterIntoSegmentEnds'

/**
 * Since passives need to be interwoven with the path ends
 * we need to special massage the data to fit them in properly.
 * first we build a list of all the passive repeaters,
 * duplicating back-to-back sets and
 * excluding sets with no value
 * @param {Array} passiveRepeaters - array of passive repeaters from path details (redux-form)
 * @param {Array} segments - array of segments that is being prepared for the API
 */
const formatPassiveRepeaters = (passiveRepeaters, segments) => {
  // first remove any passive repeaters which don't have a site name.
  // this will be present if there is an empty passive repeater in the form which the user has not filled out.
  const filteredPassiveRepeaters = passiveRepeaters.filter(passiveRepeater => passiveRepeater.site.siteName)

  filteredPassiveRepeaters.forEach((passiveRepeater, i) => {
    const {
      p1SegmentEnd,
      p2SegmentEnd,
    } = splitPassiveRepeaterIntoSegmentEnds(passiveRepeater)

    segments[i].segmentEnds.push(p1SegmentEnd)
    // duplicates the segment end data for passive repeaters in the next index
    // of the segments array due to how segments are handled in the API.
    segments[i + 1] = {
      segmentEnds: [p2SegmentEnd],
    }
  })
}

export default formatPassiveRepeaters
